import localStorageEffect from '@/utils/recoil/localStorageEffect';
import { atom } from 'recoil';

import { ThemeMode } from './types';

const THEME_MODE_STORAGE_KEY = 'baseten-theme-mode';

function isThemeMode(value: unknown): value is ThemeMode {
  return value === ThemeMode.Light || value === ThemeMode.Dark || value === ThemeMode.System;
}

const deserializeThemeMode = (rawValue: string): ThemeMode => {
  // support legacy storage where the raw string was stored (not JSON).
  if (isThemeMode(rawValue)) {
    return rawValue;
  }

  try {
    const parsed = JSON.parse(rawValue) as unknown;
    if (isThemeMode(parsed)) {
      return parsed;
    }
  } catch {
    // ignore
  }

  return ThemeMode.System;
};

const themeModeState = atom<ThemeMode>({
  key: 'theme-mode',
  default: ThemeMode.Light,
  effects: [
    localStorageEffect<ThemeMode>(THEME_MODE_STORAGE_KEY, { deserialize: deserializeThemeMode }),
  ],
});

export { THEME_MODE_STORAGE_KEY, deserializeThemeMode, isThemeMode, themeModeState };
